export interface Component {
  type: string;
  system: string;
  name: string;
  title: string;
  description: string;
  tags: string[];
}

export type ComponentType = 'service' | 'library' | 'website';

export interface Resource {
  [key: string]: string | string[] | number | number[] | boolean | boolean[];
}

export enum ResourceType {
  'gcp-sql-instance' = 'GCP-SQLInstance',
  'gcp-sql-database' = 'GCP-SQLDatabase',
  'gcp-maps-api' = 'GCP-MapsAPI',
  'gcp-storage-bucket' = 'GCP-StorageBucket',
  'gcp-secret-manager' = 'GCP-SecretManager',
  'totvs-rac' = 'Totvs-RAC',
  'totvs-identity' = 'Totvs-Identity',
  'totvs-smart-talk' = 'Totvs-SmartTalk',
  'totvs-tpd' = 'Totvs-TPD',
}

export interface DomainStructure {
  domainName: string;
  domainTitle: string;
  domainDescription: string;
  domainType: string;
  subdomainOf?: string;
  teamProject?: string;
}

export type DomainType = 'bundle' | 'product-area' | 'product-group';

export type SystemId = {
  kind: SystemIdType;
  id?: string;
};
export type SystemIdType = 'none' | 'value' | 'request';
type SystemBoolean = 'yes' | 'no' | 'unknown';

export interface System {
  owner: string;
  domain: string;
  subdomain: string;
  namespace: SystemNamespace;
  name: string;
  title: string;
  description: string;
  tags: string[];
  identityAppCode: SystemId;
  racId: SystemId;
  smartTalkId: SystemId;
  tpdId: SystemId;
  releaseProcess: boolean;
  useDatabase: boolean;
  migrationProcess: boolean;
  useConfigServer: boolean;
  segmentOrBoard: string;
  onboardingType: 'team/area' | 'namespace';
  marketing: SystemBoolean;
  dataPrivacy: SystemBoolean;
  stakeholder: string;
  productOwner: string;
  technicalResponsible: string;
  operationsResponsible: string;
  securityResponsible: string;
}

export type SystemNamespace = '' | 'supply-engenharia' | 'supply-logistica' | 'supply-fabrica' | 'agro-comercializacao';
